import Vue from 'vue'

const gloableMethods = {
  install(Vue) {
    Vue.prototype.$checkPhone = (phoneNumber, country) => {
      const China = /^1[3-9]\d{9}$/
      // 正则的本质时匹配字符串,所以/^01/.test(01)===false
      // 孟加拉号以0开头的有11位数，1开头的有10位数
      const Bangladesh10 = /^1[3-9]\d{8}$/
      const Bangladesh11 = /^01[3-9]\d{8}$/
      // 巴基斯坦手机号码
      // const Pakistan = /^0[2-9]{2,3}\d{7}$/
      // 缅甸手机号码
      // const Myanmar = /^09\d{7,9}/
      switch (country) {
        case 'China':
         return China.test(phoneNumber)
        case 'Bangladesh':
          return Bangladesh10.test(phoneNumber)
           || Bangladesh11.test(phoneNumber.toString())

        default:
          break
      }
    }
    // 处理服务器时间为当地时间
    Vue.prototype.$formatTime = function(timeStr) {
      if (timeStr) {
        return new Date(timeStr).toLocaleString()
      }
    }
    //
    Vue.prototype.$domain = function() {
      let url = ''
      switch (process.env.server) {
        case 'dev':
          url = 'https://seller-dev.perfee.com'
          break
        case 'test':
          url = 'https://seller-test.perfee.com'
          break
        case 'prod':
          url = 'https://seller.perfee.com'
          break

        default:
          url = 'https://seller-dev.perfee.com'
          break
      }
      return url
    }
    // 千分位各式处理 decimals是否保留除 .00 外的小数, true,保留, false不保留小数
    Vue.prototype.$thousands = function(num, decimals = true) {
      if (!num && ![0, '0'].includes(num)) {
        return ''
      }
      const str = decimals ? num.toString().replace('.00', '') : num.toString().split('.')[0]
      return str.replace(
        /(\d{1,3})(?=(\d{3})+(?:$|\.))/g,
        '$1,'
      )
    }
  }
}

Vue.use(gloableMethods)
